// Firebase configuration for Web App
// NOTE: This uses Web App credentials, NOT service account keys
// Service account keys with private keys should NEVER be used in frontend code

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDD4eUr1EIvLQkJS_FZvtXpI0GXoHENQM4",
  authDomain: "educado-ai.firebaseapp.com",
  projectId: "educado-ai",
  storageBucket: "educado-ai.firebasestorage.app",
  messagingSenderId: "976389174160",
  appId: "1:976389174160:web:3285133a13bb92daae7915",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

export default app;
